// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Data from "./core/Data.js";
import * as Buhta_cabinet__Home from "./Home.js";
import * as Buhta_components__ToastsList from "../../../packages/components/src/moleculas/ToastsList.js";
import * as Buhta_core__Auth from "../../../packages/core/lib/Auth.js";
import * as Buhta_core__GlobalStateContext from "../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../packages/core/lib/Toast.js";
import * as React from "react";
import * as ReactHelmetAsync from "react-helmet-async";
import * as JsxRuntime from "react/jsx-runtime";

function App(Props) {
  let state = Props.state;
  let helmetContext = Props.helmetContext;
  let data = Props.data;
  const state$1 = Buhta_core__GlobalStateContext.createGlobalStateContext(state);
  const initialIdentity = Buhta_core__Auth.getInitialIdentity(state$1.prefetched, state$1.user);
  const initialCtx = Buhta_core__Tenant.getInitialCtx(state$1.ctx);
  const match = Buhta_core__Auth.useAuthContext(initialIdentity);
  const match$1 = Buhta_core__Tenant.createTenantContext(initialCtx);
  const match$2 = Buhta_cabinet__Data.useContext(data);
  const match$3 = Buhta_core__Toast.useToastsContext(/* [] */ 0);
  return JsxRuntime.jsxs("html", {
    children: [
      JsxRuntime.jsxs("head", {
        children: [
          JsxRuntime.jsx("meta", {
            charSet: "utf-8"
          }),
          JsxRuntime.jsx("meta", {
            content: "initial-scale=1.0, width=device-width, maximum-scale=1",
            name: "viewport"
          }),
          JsxRuntime.jsx("meta", {
            content: "#232837",
            name: "theme-color"
          }),
          JsxRuntime.jsx("meta", {
            content: "#232837",
            name: "msapplication-navbutton-color"
          }),
          JsxRuntime.jsx("meta", {
            content: "yes",
            name: "mobile-web-app-capable"
          }),
          JsxRuntime.jsx("meta", {
            content: "#232837",
            name: "apple-mobile-web-app-status-bar-style"
          }),
          JsxRuntime.jsx("meta", {
            content: "001943571afdb616",
            name: "yandex-verification"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-32.png",
            integrity: "sha384-pFugN5t6rfVVdpICXr3ub2J6wfCSmoV8qtebAPuGn1SUu3bITkHVORCK6Yxu9KaZ",
            rel: "icon",
            sizes: "32x32"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-57.png",
            integrity: "sha384-0nm8nzsORJon2/aczmG0M9Np6Xib3oML+0SA+tqiZT7PdrUaqFVq7348Mvd1ky4m",
            rel: "icon",
            sizes: "57x57"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-76.png",
            integrity: "sha384-zmdDBKEfcvFZqr3CuEqlFRGRvoJpz1JOuW+vCDh4vhtB/PHZtZDhmWAfVU/W7VsC",
            rel: "icon",
            sizes: "76x76"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-96.png",
            integrity: "sha384-E5f0dbjxXykA5bFds9WhlTcAhVGwCa1oZnCPMamTkzVrlQDSuWu8rfQoFMsD1+YP",
            rel: "icon",
            sizes: "96x96"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-120.png",
            integrity: "sha384-yeCefwVm/8FQpIted9eRFeykScXmBQPSi6iIXxYVhVeWdFH5fRRMoVjFWzXvNmfT",
            rel: "icon",
            sizes: "120x120"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-128.png",
            integrity: "sha384-IUENbF5N2U5GYGrGXfxEXz76r341OLD6kJY7N7IP8t1wI+FoXvHp+sE+IeF+fAAM",
            rel: "icon",
            sizes: "128x128"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-144.png",
            integrity: "sha384-+0UyXXHofcvj1teI03w3A1EbECKkC3LiqgfrMq3r4L8WnUv9aKWEAM0KBkSwzHEi",
            rel: "icon",
            sizes: "144x144"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-152.png",
            integrity: "sha384-ZpEOeU3D3l44kABGcqNJr/RaVGLQhQ9+xrQRQEKO43dmB+xJSmFXwAi2X+7E69D7",
            rel: "icon",
            sizes: "152x152"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-167.png",
            integrity: "sha384-PtUensS0Sf5qw3tNnQ9KzA6T4DFl0hfXNaj6vHZ7ArfLIEiiZLxalKXzM8HfUJUW",
            rel: "icon",
            sizes: "167x167"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-180.png",
            integrity: "sha384-Iw/Kj/QtgJSA3bE8ivaE98CbJPKX9O/2x6V4JQ4/LTeOeYXjkJxlEQBjTrdTx1M2",
            rel: "icon",
            sizes: "180x180"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-192.png",
            integrity: "sha384-q5v9dQ+gulL1p8fL3UInTeNzZEo/+Imhif2kQ7P9IY+i6m+p4qIuJtvFBXqLyCU1",
            rel: "icon",
            sizes: "192x192"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-195.png",
            integrity: "sha384-nXsAPhH9EG2bfOaIQIR+Ne5c8uUtTbfXoh9FnqPH2N2rI56ByHyL0mggUwyThr4z",
            rel: "icon",
            sizes: "195x195"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-196.png",
            integrity: "sha384-grlpJn9a1po9VYW/WN9pAgrRXwQL68paL3zuJaYbEpnEBZqmNCqkmNO+8jyoeAAv",
            rel: "icon",
            sizes: "196x196"
          }),
          JsxRuntime.jsx("link", {
            crossOrigin: "anonymous",
            href: "https://assets.buhtacdn.com/static/icons/favicon-228.png",
            integrity: "sha384-KLaatwJyC88s9acA9NkZLgpd5oB4LNHAIhI0UimQlmYljq4cCwp2VUc5nw0k3VS5",
            rel: "icon",
            sizes: "228x228"
          }),
          JsxRuntime.jsx("link", {
            href: "/manifest.json",
            rel: "manifest"
          }),
          Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(state$1.cssAssets, (function (idx, param) {
            const integrity = param.integrity;
            return JsxRuntime.jsx("link", {
              href: param.href,
              integrity: integrity,
              rel: "stylesheet"
            }, integrity);
          })))
        ]
      }),
      JsxRuntime.jsxs("body", {
        children: [
          JsxRuntime.jsx(JitsuReact.JitsuProvider, {
            children: JsxRuntime.jsxs(ReactHelmetAsync.HelmetProvider, {
              children: [
                JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
                  children: [
                    JsxRuntime.jsx("title", {
                      children: "Бухта - онлайн бухгалтерия"
                    }),
                    JsxRuntime.jsx("meta", {
                      content: "Бухта, бухгалтерия, налоговая отчетность",
                      name: "description"
                    }),
                    JsxRuntime.jsx("meta", {
                      content: "Бухта - онлайн бухгалтерия",
                      property: "og:site_name"
                    })
                  ]
                }),
                JsxRuntime.jsx(Buhta_core__GlobalStateContext.Provider.make, Buhta_core__GlobalStateContext.Provider.makeProps(state$1, JsxRuntime.jsxs(Buhta_core__Toast.ToastsProvider.make, Buhta_core__Toast.ToastsProvider.makeProps([
                  match$3[0],
                  match$3[1]
                ], [
                  JsxRuntime.jsx(Buhta_core__Auth.IdentityProvider.make, Buhta_core__Auth.IdentityProvider.makeProps([
                    match[0],
                    match[1]
                  ], JsxRuntime.jsx(Buhta_core__Tenant.ContextProvider.make, Buhta_core__Tenant.ContextProvider.makeProps([
                    match$1[0],
                    match$1[1]
                  ], JsxRuntime.jsx(Buhta_cabinet__Data.Provider.make, Buhta_cabinet__Data.Provider.makeProps([
                    match$2[0],
                    match$2[1]
                  ], JsxRuntime.jsx(Buhta_cabinet__Home.make, {
                    payload: state$1.payload
                  }), undefined)), undefined)), undefined)),
                  JsxRuntime.jsx(Buhta_components__ToastsList.make, {})
                ], undefined)), undefined))
              ],
              context: helmetContext
            }),
            options: {
              host: "https://t.buhta.com",
              writeKey: "KrFJdzq1gqGFeSxHtmiIqXIcrD5iV0BN:cXE1KcE1iayYcUAYV8YjwsX89mkS3SoW"
            }
          }),
          React.createElement("script", {
            id: "__LOADABLE_REQUIRED_CHUNKS__",
            type: "application/json"
          }, "[]"),
          React.createElement("script", {
            id: "__LOADABLE_REQUIRED_CHUNKS___ext",
            type: "application/json"
          }, "{\"namedChunks\":[]}")
        ]
      })
    ],
    lang: "en"
  });
}

const make = App;

export {
  make,
}
/* @jitsu/jitsu-react Not a pure module */
